import styled from 'styled-components';
import colors from '../../theme/colors';
import { displayFlex } from '../../theme/css-generators';

export const LabelWrap = styled.div`
    ${displayFlex({})}
    background-color:${colors[7]}; /*colors[6] */
    padding: 5px 0px;
    color: ${colors[4]}; 
`